module.exports = __webpack_public_path__ + "static/media/work6.0433b804.webp";